<template>
  <div
    :style="{
      backgroundColor: isDarkTheme ? mainBgColor : '#dadada',
      paddingBottom: '10px'
    }"
  >
    <header-o :model="headerData"></header-o>
    <div
      class=""
      style="margin-right: 10px; margin-left: 10px; margin-top: -170px "
    >
      <div
        :style="{
          backgroundColor: isDarkTheme ? offersCardBgColor : '#ffffff',
          borderRadius: '10px'
          // padding: '10px'
        }"
        class="past-history-section common-section height-cus"
      >
        <div style="padding: 10px;" class="past-history-title text-center">
          <div
            :style="{ backgroundColor: isDarkTheme ? mainBgColor : '#ffffff' }"
            class="offer-card bg-light radius-5 padding-20 margin-bottom-10 pos-rel box-shadow "
            style="padding: 0px 20px"
          >
            <div
              class="row align-items-center"
              style="display: flex;
                justify-content: space-around;"
            >
              <div class="col-4" style="display: flex;justify-content: center;">
                <div class="winner-block">
                  <div style="margin-right: 20px;">
                    <!-- <img src="@/assets/rank-2.svg" alt="rank-2" class="img-fluid" /> -->
                    <img
                      src="@/assets/Leaderboard Assest/Time.svg"
                      class="small-icon mx-2"
                    /><span>Time Left</span>
                    <div
                      style="display: flex; margin-top: 5px;margin-left: 20px;"
                    >
                      <span
                        style="display: flex; flex-direction:column ;justify-content: center; align-items: center;"
                      >
                        <span
                          id="days"
                          style="font-size: 20px; font-weight: 400;"
                        ></span>
                        <span
                          style=" 
                          margin-left:5px; font-size: 10px; font-family: 'Montserrat';"
                          :style="{ color: '#000000', fontWeight: '600' }"
                          >Days</span
                        >
                      </span>
                      <span
                        style="display: flex; flex-direction:column ;justify-content: center; align-items: center;"
                        ><span
                          id="hours"
                          style="font-size: 20px; font-weight: 400;"
                        ></span
                        ><span
                          style="margin-left:5px; font-size: 10px; font-family: 'Montserrat';"
                          :style="{ color: '#000000', fontWeight: '600' }"
                          >Hrs</span
                        ></span
                      >
                      <span
                        style="display: flex; flex-direction:column ;justify-content: center; align-items: center;"
                        ><span
                          id="mins"
                          style="font-size: 20px; font-weight: 400;"
                        ></span
                        ><span
                          style="margin-left:5px; font-size: 10px; font-family: 'Montserrat';"
                          :style="{ color: '#000000', fontWeight: '600' }"
                          >Min</span
                        ></span
                      >
                      <span
                        style="display: flex; flex-direction:column ;justify-content: center; align-items: center;"
                        ><span
                          id="seconds"
                          style="font-size: 20px; font-weight: 400;"
                        ></span
                        ><span
                          style="margin-left:5px; font-size: 10px; font-family: 'Montserrat';"
                          :style="{ color: '#000000', fontWeight: '600' }"
                          >Sec</span
                        ></span
                      >
                    </div>

                    <!-- <p class="m-3"><span id="days">0</span> : <span id="hours">0</span>: <span id="mins">0</span>: <span id="seconds">0</span></p>
                    <p>Days : Hrs : Mins : sec</p> -->
                  </div>
                </div>
              </div>
              <div class="vl"></div>
              <div class="col-4">
                <div class="winner-block first-rank">
                  <div style="display:flex ">
                    <!-- <img src="@/assets/rank-1.svg" alt="rank-1" class="img-fluid" /> -->
                    <!-- <img
                      src="@/assets/Profile-img.png"
                      class="small-icon mx-2"
                    /> -->
                    <img
                      src="@/assets/ic_man_flyy.png"
                      style="width: 17px; height: 17px; border-radius: 50%; margin-right: 5px; margin-top: 1px;"
                    />
                    <span>Participants</span>
                  </div>
                  <p
                    style=" margin-left: 10px; font-size: 27px; font-weight: 500 !important; margin-bottom: 0px !important; margin-top: 5px !important;"
                  >
                    {{
                      leadeboardData.players < 0 ? 0 : leadeboardData.players
                    }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Winner Section Start -->
        <div
          class="winner-section text-center"
          v-if="
            leadeboardData.leaderboard && leadeboardData.leaderboard.length >= 3
          "
        >
          <div class="title" style="margin-top: 10px;">
            <span>Current Rankings </span>
          </div>

          <div
            class="row align-items-center"
            style="display: flex;
                justify-content: center;"
          >
            <div class="col-2">
              <div class="winner-block">
                <img src="@/assets/rank-2.svg" alt="rank-2" class="img-fluid" />
                <p style="font-weight: 600; font-size: 12px !important;">
                  {{ leadeboardData.leaderboard[1].user_name }}
                </p>
              </div>
            </div>
            <div class="col-2">
              <div class="winner-block first-rank">
                <img src="@/assets/rank-1.svg" alt="rank-1" class="img-fluid" />
                <p style="font-weight: 600; color: #373535 !important;">
                  {{ leadeboardData.leaderboard[0].user_name }}
                </p>
              </div>
            </div>
            <div class="col-2">
              <div class="winner-block">
                <img src="@/assets/rank-3.svg" alt="rank-3" class="img-fluid" />
                <p style="font-weight: 600; font-size: 12px !important;">
                  {{ leadeboardData.leaderboard[2].user_name }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <!-- Winner Section End -->

        <!-- History Table Start -->
        <div
          class="history-table"
          v-if="
            leadeboardData.leaderboard && leadeboardData.leaderboard.length != 0
          "
        >
          <div
            class="table-responsive past-history-title"
            style="box-sizing: border-box;"
          >
            <table class="table table-borderless">
              <thead>
                <tr>
                  <th><span>Rank</span></th>
                  <th><span>User</span></th>
                  <th>
                    <span>{{ leadeboardData.reward_type }}</span>
                  </th>
                </tr>
              </thead>
              <tbody v-if="leadeboardData.user_data" style="color: #544E4E;">
                <tr
                  v-if="leadeboardData && leadeboardData.leaderboard.length > 2"
                  :style="{
                    backgroundColor: isDarkTheme ? mainBgColor : '#dadada'
                  }"
                >
                  <td>{{ "# " + leadeboardData.user_data.rank }}</td>
                  <td class="name">{{ leadeboardData.user_data.user_name }}</td>
                  <td>{{ leadeboardData.user_data.score }}</td>
                </tr>
                <tr v-for="item in leadeboardData.leaderboard">
                  <td>{{ "# " + item.rank }}</td>
                  <td class="name">{{ item.user_name }}</td>
                  <td>{{ item.score }}</td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr v-for="item in leadeboardData.leaderboard">
                  <td>{{ "# " + item.rank }}</td>
                  <td class="name">{{ item.user_name }}</td>
                  <td>{{ item.score }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <!-- History Table End -->
        <!-- <hr width="80%" /> -->
        <!-- <div
          v-if="
            leadeboardData.leaderboard && leadeboardData.leaderboard.length > 10
          "
          @click="showMore"
        >
          <p>+{{ leadeboardData.leaderboard.length - 10 }} more players</p>
        </div> -->
        <div
          v-if="
            leadeboardData.leaderboard && leadeboardData.leaderboard.length == 0
          "
        >
          <p style="margin-top: 30px; font-size: 18px;">
            {{ leadeboardData.message }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { globals } from "@/mixins/globals";
import axios from "axios";
import OverlapHeader from "@/components/overlapped-header";
import moment from "moment";

export default {
  mixins: [globals],
  components: {
    "header-o": OverlapHeader
  },
  data() {
    return {
      headerData: {
        onlyHeader: true,
        isLeaderBoardHistory: true,
        leaderBoardId: "",
        showmore: false,
        quizHistory: false
      },
      intervalid: null,
      is_shimmer: true,
      targetEventDate: null,
      months: [1, 3, 5, 8, 10], //months have 30 or 28 or 29 days
      leadeboardData: {},
      remaining_days: 0
    };
  },
  computed: {
    isDarkTheme() {
      // ✅ Guard for sdkEvent and themeColors
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.isDarkTheme &&
        this.$store.state.sdkEvent.isDarkTheme
      ) {
        return this.$store.state.sdkEvent.isDarkTheme;
      }
      return null; // fallback
    },
    mainBgColor() {
      // ✅ Guard for sdkEvent and themeColors
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.mainBgColor
      ) {
        return this.$store.state.sdkEvent.themeColors.mainBgColor;
      }
      return null; // fallback
    },
    offersCardBgColor() {
      // ✅ Guard for sdkEvent and themeColors
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.shadowBgColor
      ) {
        return this.$store.state.sdkEvent.themeColors.offersCardBgColor;
      }
      return null; // fallback
    },
    showShimmer: function() {
      return this.is_shimmer;
    }
  },
  beforeMount() {
    var self = this;
    if (window.addEventListener) {
      window.addEventListener("message", self.handleSDKMessage, false);
    } else {
      window.attachEvent("onmessage", self.handleSDKMessage);
    }
    this.loadDataFromCookie();

    this.intervalid = setInterval(function() {
      var currentDate = new Date();
      var currentYear = currentDate.getFullYear();
      var cDateMillisecs = moment().valueOf();
      var tDateMillisecs = moment(self.targetEventDate).valueOf();
      var difference = tDateMillisecs - cDateMillisecs;
      var seconds = Math.floor(difference / 1000);
      var minutes = Math.floor(seconds / 60);
      var hours = Math.floor(minutes / 60);
      var days = Math.floor(hours / 24);
      // var isleapYear =
      //   (0 == currentYear % 4 && 0 != currentYear % 100) ||
      //   0 == currentYear % 400
      //     ? 1
      //     : 0;
      // days %= self.months.includes(currentDate.getMonth())
      //   ? currentDate.getMonth() == 1
      //     ? isleapYear == 1
      //       ? 29
      //       : 28
      //     : 30
      //   : 31;
      // self.remaining_days = days;

      hours %= 24;
      minutes %= 60;
      seconds %= 60;
      days = days < 10 ? "0" + days : days;
      hours = hours < 10 ? "0" + hours : hours;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      seconds = seconds < 10 ? "0" + seconds : seconds;

      document.getElementById("days").innerText = days + ":";
      document.getElementById("hours").innerText = hours + ":";
      document.getElementById("mins").innerText = minutes + ":";
      document.getElementById("seconds").innerText = seconds;
    }, 1000);
  },
  beforeDestroy() {
    clearInterval(this.intervalid);
  },
  methods: {
    getLeaderboardData(id) {
      this.headerData.leaderBoardId = id;
      axios.all([this.getLeaderboard(id)]).then(
        axios.spread(resp => {
          if (resp.status == 200) {
            var data = resp.data;
            console.log("Leaderboard Data ->", data);
            this.targetEventDate = resp.data.ends_at;

            this.fullListData = { ...data };
            console.log("Full-List --->", this.fullListData);
            this.leadeboardData = { ...data };
            console.log("Lead - ", this.leadeboardData);

            // var leaderboard = data.leaderboard.filter((item, index) => {
            //   if (index < 10) {
            //     return item;
            //   }
            // });
            this.leadeboardData = { ...data, leaderboard };
          }
        })
      );
    },
    showMore() {
      this.leadeboardData = this.fullListData;
    }
  },
  created() {
    var store_state = this.$store.state;
    store_state.showHeader = false;
    store_state.showWallet = false;
    store_state.showHistory = false;
    store_state.user.headerBalance.show = false;
    store_state.headTitle = "Leaderboard";
    document.documentElement.style.setProperty(
      "--bg-color",
      this.$store.state.bg_theme
    );
    document.documentElement.style.setProperty(
      "--bg-light-color",
      this.$store.state.bg_theme + "59"
    );
    if (!this.isEmpty(this.$route.params)) {
      this.getLeaderboardData(this.$route.params.id);
    }
  }
};
</script>
<style scoped>
@import "../../assets/quiz-styles/quiz-styles.css";
@import "../../assets/quiz-styles/bootstrap.css";
@import "../../assets/fonts/quiz-fonts/fonts.css";
.vl {
  border-left: 1px solid #b9b9b9;
  height: 106px;
  /* position: absolute; */
  left: 50%;
  margin-left: 7px;
  top: 0;
}
.past-history-title span {
  font-family: "Montserrat-bold", sans-serif;
  font-size: 14px;
  line-height: 19px;
  color: #373535;
  font-weight: 600;
}
.table-responsive {
  display: block;
  /* width: 100%; */
  overflow-x: auto;
}

/* Very small phones (iPhone SE, older Android) */
@media (max-width: 360px) {
  .height-cus {
    min-height: 100vh;
  }
}

/* Normal mobiles (iPhone 12/13/14/15, Samsung A/M series) */
@media (min-width: 361px) and (max-width: 480px) {
  .height-cus {
    min-height: 100vh;
  }
}
</style>
